import { Container, Stack, Typography, Box, Button, Backdrop, CircularProgress } from "@mui/material";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Context } from "../App";
import TicketInfo from "../components/forms/TicketInfo";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";

export default function TicketInfoForm() {
    const { isConnected, setIsConnected, userId } = React.useContext(Context);
    const { id } = useParams();
    
    const [load, setLoad] = React.useState(true);
    const [event, setEvent] = React.useState('');
    const [tickets, setTickets] = React.useState([]);

    async function handleSubmit(e) {
        e.preventDefault();
        setLoad(true);

        fetch(`${process.env.REACT_APP_API_URL}/billets`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token') || localStorage.getItem('anonUserId') || ''}`
            },body: JSON.stringify(tickets)
        })
        .then(response => { 
            const token = response.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            window.location.href = isConnected ? '/panier' : '/connexion?redirect=/panier';
        })
        .catch(error => {
            console.error('Error updating tickets:', error);
            setLoad(false);
            alert('Une erreur est survenue lors de la mise à jour des tickets. Veuillez réessayer.');
        });
    }

    useEffect(()=>{
        const query = new URLSearchParams({event: id}).toString()
        fetch(`${process.env.REACT_APP_API_URL}/public/billets/${id}`, { method: 'GET', headers:{
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${isConnected ? localStorage.getItem('token') : localStorage.getItem('anonUserId') || ''}` 
        } })
        .then(response => {
            const token = response.headers.get('x-auth-token');
            if (token) localStorage.setItem('token', token);
            if (!response.ok) {
                throw new Error('Failed to fetch tickets');
            }
            return response.json();
        })
        .then(data => {
            setEvent(data.event);
            setTickets(data.billets || []);
            setLoad(false);
        })
        .catch(error => console.error('Error fetching event:', error));
    }, [id]);

    return(
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Header />
            <Box component="form" onSubmit={handleSubmit} sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <Container maxWidth="md" sx={{ px: { xs: 2, md: 0 } }}>
                    <Typography variant="h4" align="center" sx={{ mt: 4 }}>
                    Informations Participants
                    </Typography>
                    <Stack spacing={2} sx={{ mt: 4 }}>
                    {tickets.sort((a, b) => (a.tarif < b.tarif ? -1 : 1)).map((billet, index) => (
                        <TicketInfo
                        key={index}
                        event={event}
                        billet={billet}
                        setBillet={(updatedBillet) => setTickets((old) => old.map((b, i) => (i === index ? updatedBillet : b)))}
                        index={index}
                        />
                    ))}
                    </Stack>
                </Container>

                <Button variant="contained" type="submit" color="primary" sx={{ mt: 4, alignSelf: 'center' }}>
                    Poursuivre la réservation
                </Button>

                {!isConnected && (
                    <Typography variant="h6" align="center" sx={{ mt: 4, mx: 1 }}>
                    Vous devez vous connecter ou créer un compte pour poursuivre l'inscription.<br />
                    Après la mise à jour de vos informations, vous serez redirigé vers la page de connexion.
                    </Typography>
                )}
            </Box>


            {/* <Box component='form' onSubmit={handleSubmit} sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <Container maxWidth="md">
                    <Typography variant="h4" align="center" sx={{ mt: 4 }}>
                        Informations Participants
                    </Typography>
                    <Stack spacing={2} sx={{ mt: 4 }}>
                        {tickets.sort((a,b)=>a.tarif<b.tarif?-1:1).map((billet, index) => (
                            <TicketInfo key={index} event={event} billet={billet} setBillet={(updatedBillet) => setTickets(old => old.map((b, i) => i === index ? updatedBillet : b))} index={index} />
                        ))}
                    </Stack>
                </Container>

                <Button variant="contained" type="submit" color="primary" sx={{ mt: 4, alignSelf:'center' }}>
                    Poursuivre la réservation
                </Button>

                {!isConnected && <Typography variant="h6" align="center" sx={{ mt: 4 }}>
                    Vous devez vous connecter ou créer un compte pour poursuivre l'inscription.<br/>
                    Après la mise à jour de vos informations, vous serez redirigé vers la page de connexion.
                </Typography>}
            </Box> */}
            <Footer />
            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}